export class User {
    constructor(
        public username: string | null,
        public email: string | null,    
        public name: string | null,
    ){}
}